import { render, staticRenderFns } from "./SendCodeStep.vue?vue&type=template&id=4a7bd602"
import script from "./SendCodeStep.vue?vue&type=script&lang=js"
export * from "./SendCodeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports